<template>
  <div class="about-section container-about">
    
    <div class="row">
        <div class="col-12">
          <p class="description-our-mistica">
            El mundo cambió, y ya no basta con repetir lo que funcionó antes; 
            hoy, lo más valioso que podemos darle a los hijos (as) es ayudarlos (as) 
            a descubrir quienes son, en qué se destacan y a construir su camino en un 
            futuro que nadie puede predecir.
          </p>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
          <h2 class="mistica-style text-center">¿Qué hacemos distinto?</h2>
        </div>
    </div>
    <div class="row spacing-make">
      <div class="col-6 spacing-col">
        <h3 class="title-why">1. Claridad sin imponer caminos</h3>
        <p class="description-why">
          En Talentinus no decimos qué debe estudiar tu hijo; lo ayudamos a descubrir quién es, qué lo motiva y cómo puede construir un camino propio, con un Arquetipo personalizado basado en su perfil auténtico.
        </p>
      </div>
      <div class="col-6 spacing-col">
        <h3 class="title-why">2. Preparación real para el futuro</h3>
        <p class="description-why">
          Frente a un mundo laboral incierto, brindamos información sobre la empleabilidad futura según el perfil del estudiante, para tomar decisiones educativas viables, motivadoras y sostenibles emocional y económicamente.
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <p class="description-our-make">
          El futuro incierto ya llegó: <br> La inteligencia artificial y la transformación constante son la nueva norma.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CompanyCultureSection'
}
</script>

<style scoped>
.about-section {
    width: 100%;
    height: 1755px;
    background: url('../../assets/img/image\ 9.jpg') no-repeat top center;
    background-size: contain;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding: 20px;
    box-sizing: border-box;
    /* Agrega espacio arriba igual a la altura de la imagen */
    padding-top: 400px; /* Ajusta este valor a la altura de tu imagen */
}

.row:first-of-type {
  margin-top: 400px; /* Ajusta según la altura de tu imagen */
}

.spacing-make {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  gap: 32px; /* Espacio entre columnas */
  margin-bottom: 32px;
}

.spacing-col {
  flex: 0 1 80%;
  max-width: 500px;
}

.title-why {
  font-family: 'Montserrat', sans-serif;
  font-size: 20px;
  font-weight: 700;
  line-height: 119%;
  text-align: left;
  color: #FFFFFF;
  margin: 0px 20px;
  padding: 0px 30px;
  white-space: pre-line;
  transform: scaleY(1.1);
}

.description-why {
  font-family: 'Montserrat', sans-serif;
  font-size: 20px;
  font-weight: 500;
  line-height: 119%;
  text-align: left;
  color: #FFFFFF;
  padding-top: 30px;
  transform: scaleY(1.1);
}

@media (max-width: 768px) {
  .about-section {
    height: auto;
    min-height: 320px;
    padding: 12px 0 12px 0;
    padding-top: 0; /* Elimina el espacio superior para móvil */
    background: none !important; /* Quita la imagen de fondo en móvil */
  }
  .about-section::before {
    content: "";
    display: block;
    width: 100vw;
    height: 180px; /* Ajusta la altura según la imagen */
    background: url('../../assets/img/image 9.jpg') no-repeat top center;
    background-size: contain;
    margin-bottom: 16px;
  }
  .row:first-of-type {
    margin-top: 0;
  }
  .spacing-make {
    flex-direction: column !important;
    gap: 32px !important; /* Más separación entre los dos col */
    margin-bottom: 18px;
    align-items: center !important;
    justify-content: center !important;
    width: 100%;
    padding: 0;
  }
  .spacing-col {
    max-width: 100%;
    flex: 1 1 100%;
    padding: 0 8px !important;
    box-sizing: border-box;
    text-align: center;
  }
  .title-make {
    font-size: 1.1rem !important;
    padding: 0 2vw;
    line-height: 1.2;
    text-align: center;
  }
  .description-make {
    font-size: 0.97rem !important;
    padding: 0 2vw !important;
    line-height: 1.3 !important;
    text-align: center;
  }
  .title-why {
    font-size: 1.1rem !important;
    padding: 0 2vw;
    line-height: 1.2;
    text-align: center;
    margin-bottom: 14px;
    margin-top: 8px;
  }
  .description-why {
    font-size: 0.97rem !important;
    padding: 0 2vw !important;
    line-height: 1.3 !important;
    text-align: center;      /* <-- Centrado para móvil */
    padding-top: 18px;       /* Menos espacio arriba para mejor ajuste */
    margin-bottom: 0;
    width: 100vw;            /* Ocupa todo el ancho de la pantalla */
    box-sizing: border-box;
    max-width: 100%;
  }
  .mistica-style.text-center {
    font-size: 2rem !important;
    padding: 0 2vw !important;
    line-height: 1.2 !important;
    margin-bottom: 12px !important;
    margin-top: 8px !important;
  }
}
</style>

